import { Button, Card, DatePicker, Form, InputNumber } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import {
  buttonLabel,
  cardConfig,
  dateFormat,
  formConfig,
  messages,
  placeHolders,
} from '../../../../constants';
import { CancelButton, CustomSelect } from '../../../uiComponents';
import {
  consignOrderRefundConst,
  refundStatus,
} from '../../../../constants/ConsignOrderRefund.const';
import {
  createConsignmentOrderRefund,
  getConsignmentOrderRefundById,
  updateConsignmentOrderRefund,
} from '../../../../appRedux/actions';
import { ConsignmentOrderMovement } from '../../ConsignmentOrderBilling/ConsignmentOrderMovement';

export const ConsignmentOrderRefundForm = ({
  consignmentOrderId,
  numberOrder,
  consignmentOrderRefundId,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [formDisabled, setFormDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const isEditMode = Boolean(consignmentOrderRefundId);
  const url = `/dashboard/devolucion-de-consigna/${consignmentOrderId}/${numberOrder}`;
  const { consignmentOrderRefundById } = useSelector(
    (state) => state.consignmentOrderRefund
  );
  const isApprove =
    consignmentOrderRefundById?.status === consignOrderRefundConst.approve;
  const movements = Form.useWatch('movements', form);

  const hasProducts = Object.values(movements || {}).some(
    (quantity) => Number(quantity) > 0
  );

  useEffect(() => {
    if (isEditMode) {
      dispatch(getConsignmentOrderRefundById(consignmentOrderRefundId));
    }
  }, [consignmentOrderRefundId, dispatch, isEditMode]);

  //Mapear el dato en el form
  useEffect(() => {
    if (
      isEditMode &&
      consignmentOrderRefundById &&
      consignmentOrderRefundById.consignmentOrderRefundProduct
    ) {
      form.setFieldsValue({
        refundAt: consignmentOrderRefundById.refundAt
          ? moment(consignmentOrderRefundById.refundAt)
          : null,
        status: consignmentOrderRefundById.status,
        total: consignmentOrderRefundById.total,
        movements:
          consignmentOrderRefundById.consignmentOrderRefundProduct.reduce(
            (acc, item) => {
              acc[item.consignmentOrderProduct.id] = item.quantity;
              return acc;
            },
            {}
          ),
      });
    }
  }, [isEditMode, consignmentOrderRefundById, form]);

  useEffect(() => {
    setFormDisabled(isEditMode && isApprove);
  }, [isEditMode, isApprove]);

  const onSubmit = async (values) => {
    setIsLoading(true);

    const items = Object.entries(values.movements || {})
      .filter(([_, quantity]) => quantity > 0)
      .map(([consignmentOrderProductId, quantity]) => ({
        consignmentOrderProductId,
        quantity,
      }));

    const payload = {
      consignmentOrderId,
      payMethod: values.payMethod,
      refundAt: values.refundAt
        ? moment(values.refundAt).format(dateFormat)
        : undefined,
      status: values.status,
      total: Number(values.total),
      items,
    };

    let result;
    if (isEditMode) {
      result = await dispatch(
        updateConsignmentOrderRefund(consignmentOrderRefundId, payload)
      );
    } else {
      result = await dispatch(createConsignmentOrderRefund(payload));
    }

    if ([200, 201].includes(result)) {
      navigate(url);
    }

    setIsLoading(false);
  };

  return (
    <Card size="small" bordered style={cardConfig}>
      <Form
        id="onSubmitConsignment"
        autoComplete="off"
        onFinish={onSubmit}
        form={form}
        disabled={formDisabled}
      >
        <Form.Item
          {...formConfig}
          name="status"
          label="Estado de devolucion"
          rules={[
            {
              required: true,
              message: messages.required('Estado de devolucion'),
            },
          ]}
        >
          <CustomSelect
            placeholder={placeHolders.refundStatus}
            options={refundStatus.map(({ value, label }) => ({
              value,
              label,
            }))}
          />
        </Form.Item>

        <Form.Item
          {...formConfig}
          name="refundAt"
          label="Devuelto en"
          rules={
            isEditMode
              ? [
                  {
                    required: true,
                    message: messages.required('Devuelto en'),
                  },
                ]
              : []
          }
        >
          <DatePicker style={{ width: '100%' }} format={dateFormat} />
        </Form.Item>

        <Form.Item
          {...formConfig}
          name="total"
          label="Total"
          rules={[{ required: true, message: messages.required('Total') }]}
        >
          <InputNumber placeholder="Total" />
        </Form.Item>

        <div style={{ marginTop: 30 }}>
          <ConsignmentOrderMovement
            ConsignmentOrderId={consignmentOrderId}
            disabled={isEditMode}
            isRefund={true}
          />
        </div>

        <div style={{ marginTop: 20 }}>
          <Button
            type="primary"
            htmlType="submit"
            className="btn-form"
            disabled={isLoading || formDisabled || !hasProducts}
          >
            {buttonLabel.save}
          </Button>
        </div>
      </Form>
      <CancelButton path={url} />
    </Card>
  );
};
